import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faPlus } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useLocation } from 'react-router-dom';
import Phonepay from './images/Phonepay.png';
import Paytm from './images/Paytm.png';
import GooglePay from './images/Google.png';
import Cred from './images/Cred.png';
import ArrowLeft from './images/ArrowLeft.png';
import MagneticCard from './images/MagneticCard.png';
import PhoneSpinner from './images/PhoneSpinner.png';
import Header from './Component/Header1';

const UpiPayments = ({ onBack, onAddNew }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [showPopup, setShowPopup] = useState(false);
  const [upiId, setUpiId] = useState('');
  const [saveForFuture, setSaveForFuture] = useState(true);  
  const [savedUpiIds, setSavedUpiIds] = useState([]); 
  const [loading, setLoading] = useState(false);
  const [loadingUpiId, setLoadingUpiId] = useState(null);
  const [lastUsedUpiId, setLastUsedUpiId] = useState(''); 
  const [pageLoading, setPageLoading] = useState(true);
  const [useThisLoading, setUseThisLoading] = useState(false);
  const [popupPayLoading, setPopupPayLoading] = useState(false);

  const fetchUrl = process.env.REACT_APP_FORE_BRICKBUCKET;

  // Get quotation data from location state
  const { rfq_id, quotationData, totalAmount, quotationId, quotationNumber } = location.state || {};
  
  // Format amount for display
  const formattedAmount = totalAmount ? Math.round(totalAmount).toLocaleString() : '0';
  console.log('quotation data:', quotationData);

  useEffect(() => {
    fetchLastUpiPayment(); // This only fetches and stores in lastUsedUpiId, doesn't add to savedUpiIds
  }, []);

  const handleAddNewClick = () => {
    setShowPopup(true);
  };

  const handleClosePopup = () => {
    setShowPopup(false);
    setUpiId('');
    setSaveForFuture(true);
  };

useEffect(() => {
  const timer = setTimeout(() => {
    setPageLoading(false);
  }, 1000);

  return () => clearTimeout(timer);
}, []);


  const handleUseLastUsedUpi = () => {
  setUseThisLoading(true);
  
  setTimeout(() => {
    setUpiId(lastUsedUpiId);
    if (!savedUpiIds.includes(lastUsedUpiId)) {
      setSavedUpiIds(prev => [...prev, lastUsedUpiId]);
    }
    setUseThisLoading(false);
    handleClosePopup(); 
  }, 1000);
};


  const handlePayClick = async () => {
  // Validate UPI ID
  if (!upiId.trim()) {
    alert('Please enter a valid UPI ID');
    return;
  }
  
  setPopupPayLoading(true);
  
  setTimeout(() => {
   
    if (saveForFuture && !savedUpiIds.includes(upiId)) {
      setSavedUpiIds(prev => [...prev, upiId]);
    }
    setPopupPayLoading(false); 
    handleClosePopup();
  }, 1000);
};


  // Handle UPI app navigation
  const handleUpiAppClick = (appName) => {
    console.log('Payment with', appName);
    console.log('Quotation ID:', quotationId);
    console.log('Amount:', totalAmount);
    
    switch(appName) {
      case 'PhonePe':
        window.location.href = 'phonepe://pay';
        break;
      case 'Paytm':
        window.location.href = 'paytmmp://pay';
        break;
      case 'GooglePay':
        window.location.href = 'tez://upi/pay';
        break;
      case 'CRED':
        window.location.href = 'cred://pay';
        break;
      default:
        console.log(`${appName} clicked`);
    }
  };

  const processPayment = async (upiId) => {
    try {
      setLoadingUpiId(upiId); 
      setLoading(true);
      
      const token = sessionStorage.getItem('token');
      const UserData = JSON.parse(sessionStorage.getItem('userData'));
      const paymentData = {
        order_id: quotationData.quotation_id,
        payment_mode: "UPI",
        amount: quotationData?.total,
        customer_id: quotationData?.customer_id,
        project_id: quotationData?.project_id,
        hubId: UserData?.hubId,
        upi_details: {
          upi_id: upiId,
          transaction_id: `TXN${Date.now()}`,
          //payer_name: quotationData.customer_id.customer_name
        },
        gateway_details: {
          gateway_name: "RAZORPAY",
          gateway_transaction_id: `pay_${Date.now()}`,
          gateway_payment_id: `pay_${Date.now()}`
        },
        description: 'Payment for construction materials',
      };

      console.log('🔍 VERIFYING PAYMENT DATA:');
      console.log('UPI ID entered:', upiId);
      console.log('Complete Payment Data:', paymentData);

      const response = await fetch(`${fetchUrl}customer/salesorder/process-customer-payment`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
        body: JSON.stringify(paymentData)
      });

      const result = await response.json();
      console.log('Payment Result:', result);

      if (result.success) {
        // Keep loading state until navigation
        setTimeout(() => {
       /*    navigate('/consumer/app/orderdetails', {
            state: {
              quotationId: quotationData._id,
              paymentCompleted: true
            }
          }); */
         navigate("/consumer/projectdetails", { replace: true });

navigate("/consumer/app/rfqdetails", {
    state: {
      rfq_id: rfq_id,
      quotationId: quotationData.quotation_id,
      paymentCompleted: true
    }
  });
}, 1000);

      } else {
        alert(result.message || 'Payment failed. Please try again.');
        setLoadingUpiId(null);
        setLoading(false);
      }

    } catch (error) {
      console.error('Payment processing error:', error);
      alert('Payment processing failed. Please try again.');
      setLoadingUpiId(null);
      setLoading(false);
    }
  };

  const fetchLastUpiPayment = async () => {
    try {
      const token = sessionStorage.getItem('token');
      const userData = JSON.parse(sessionStorage.getItem('userData'));
      const customerId = userData?._id;

      if (!customerId) {
        console.log('No customer ID found');
        return;
      }

      const apiUrl = `${fetchUrl}payments/get-last-payment-details-by-paymentmode-and-customer?customer_id=${customerId}&payment_mode=UPI`;
      
      console.log('🔍 API URL:', apiUrl);

      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token,
        },
      });

      if (!response.ok) {
        console.error('❌ Response not ok:', response.status, response.statusText);
        return;
      }

      const result = await response.json();
      console.log('✅ Last UPI payment result:', result);
      
      if (result.success && result.data) {
        // Try different possible field names for UPI ID
        const upi_id = result.data.upi_id || 
                       result.data.upi_details?.upi_id || 
                       result.data.payment_details?.upi_id ||
                       result.data.upiId;
        
        console.log('🔍 Extracted UPI ID:', upi_id);
        
        // Only set lastUsedUpiId, don't add to savedUpiIds automatically
        if (upi_id) {
          setLastUsedUpiId(upi_id);
        } else {
          console.log('⚠️ No UPI ID found in the response');
        }
      }
    } catch (error) {
      console.error('❌ Error fetching last UPI payment:', error);
    }
  };


  if (pageLoading) {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center  bg-opacity-70 backdrop-blur-sm z-50">
      {/* 🔴 Red spinning circle */}
      <div className="w-8 h-8 border-2 border-red-400 border-t-transparent rounded-full animate-spin"></div>
      
      {/* Text below loader */}
      <p className="mt-4 text-gray-400 text-xs">Loading payments...</p>
    </div>
  );
}


  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {/* Header */}
      <div className="w-full px-1 py-4 flex items-center border-b border-gray-200 bg-white sticky top-0 z-10 h-14">
        <img
          src={ArrowLeft}
          className="w-12 h-8 text-gray-600 mr-1 cursor-pointer"
          onClick={onBack || (() => navigate(-1))}
        />
        <h2 className="text-lg font-semibold text-gray-900">UPI Payments</h2>
      </div>



      {/* UPI Apps List */}
      <div className="px-4 mt-6 space-y-2">
        {/* Saved UPI IDs - Only show when user has added them */}
        {savedUpiIds.length > 0 && savedUpiIds.map((savedUpi, index) => (
          <div
            key={index}
            className="border border-gray-300 rounded-md bg-white px-4 py-2"
          >
            {/* UPI ID Row */}
            <div className="flex items-center mb-2">
              <div className="w-10 h-10 mr-3 flex items-center justify-center">
                <img src={MagneticCard} alt="UPI Card" className="w-8 h-8 object-contain" />
              </div>
              <span className="font-bold text-sm text-[#524D4D]">{savedUpi}</span>
            </div>
            
            {/* Pay Button Row with left margin */}
            <div className="ml-12">
              <button
                className={`w-full text-white px-4 py-2 rounded-md text-sm font-bold transition-colors ${
                  loadingUpiId === savedUpi 
                    ? 'bg-[#F43042] cursor-not-allowed' 
                    : 'bg-[#F43042] hover:bg-red-600'
                }`}
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  console.log('Saved UPI Pay button clicked:', savedUpi);
                  processPayment(savedUpi);
                }}
                disabled={loadingUpiId === savedUpi}
                type="button"
              >
                {loadingUpiId === savedUpi ? 'Processing...' : `Pay ₹${formattedAmount}`}
              </button>
            </div>
          </div>
        ))}

        {/* PhonePe */}
        <div 
          className="flex items-center border border-gray-200 rounded-md bg-white px-4 py-2 cursor-pointer hover:bg-gray-50 transition-colors"
          onClick={() => handleUpiAppClick('PhonePe')}
        >
          <div className="bg-[#F5F5F5] rounded-md w-10 h-10 mr-4 flex items-center justify-center">
            <img src={Phonepay} alt="PhonePe" className="w-8 h-8 object-contain" />
          </div>
          <span className="font-bold text-sm text-[#524D4D]">PhonePe</span>
        </div>

        {/* Paytm */}
        <div 
          className="flex items-center border border-gray-200 rounded-md bg-white px-4 py-2 cursor-pointer hover:bg-gray-50 transition-colors"
          onClick={() => handleUpiAppClick('Paytm')}
        >
          <div className="bg-[#F5F5F5] rounded-md w-10 h-10 mr-4 flex items-center justify-center">
            <img src={Paytm} alt="Paytm" className="w-8 h-8 object-contain" />
          </div>
          <span className="font-bold text-sm text-[#524D4D]">Paytm</span>
        </div>

        {/* Google Pay */}
        <div 
          className="flex items-center border border-gray-200 rounded-md bg-white px-4 py-2 cursor-pointer hover:bg-gray-50 transition-colors"
          onClick={() => handleUpiAppClick('GooglePay')}
        >
          <div className="bg-[#F5F5F5] rounded-md w-10 h-10 mr-4 flex items-center justify-center">
            <img src={GooglePay} alt="Google Pay" className="w-8 h-8 object-contain" />
          </div>
          <span className="font-bold text-sm text-[#524D4D]">Google Pay</span>
        </div>

        {/* CRED */}
        <div 
          className="flex items-center border border-gray-200 rounded-md bg-white px-4 py-2 cursor-pointer hover:bg-gray-50 transition-colors"
          onClick={() => handleUpiAppClick('CRED')}
        >
          <div className="bg-[#F5F5F5] rounded-md w-10 h-10 mr-4 flex items-center justify-center">
            <img src={Cred} alt="CRED" className="w-8 h-8 object-contain" />
          </div>
          <span className="font-bold text-sm text-[#524D4D]">CRED</span>
        </div>

        {/* Add New UPI ID */}
        <div
          className="flex items-center border border-gray-200 rounded-md bg-white px-4 py-2 cursor-pointer hover:bg-gray-50 transition-colors"
          onClick={handleAddNewClick}
        >
          <div className="bg-[#F5F5F5] rounded-md w-10 h-10 mr-4 flex items-center justify-center">
            <FontAwesomeIcon icon={faPlus} className="text-[#C20C0C] w-4 h-4" />
          </div>
          <span className="font-bold text-sm text-[#C20C0C]">Add New UPI ID</span>
        </div>
      </div>

    
          {/* Popup */}
      {showPopup && (
        <>
          {/* Backdrop */}
          <div className="fixed inset-0 bg-black bg-opacity-50 z-40" onClick={handleClosePopup}></div>
          
          {/* Popup Content - Changed from bottom to top */}
          <div className="fixed top-20 left-4 right-4 bg-white rounded-2xl z-50 max-w-md mx-auto shadow-2xl">
            <div className="w-20 h-1 bg-[#E0D9D9] rounded-full mx-auto mt-5"  onClick={handleClosePopup}></div>
      
            
            <div className="p-6 pt-3">
              <h3 className="text-md font-bold text-[#000000] mb-4 text-center">Add New UPI ID</h3>
              
              {/* Last Used UPI Option - Show only if lastUsedUpiId exists */}
              {lastUsedUpiId && (
                <div className="mb-4 p-3 border border-green-200 rounded-md bg-green-50">
                  <p className="text-sm text-gray-600 mb-2">💳 Use your last used UPI ID:</p>
                  <div className="flex items-center justify-between">
                    <span className="font-medium text-sm text-gray-800">{lastUsedUpiId}</span>
                   <button
        onClick={handleUseLastUsedUpi}
        disabled={useThisLoading}
        className={`px-3 py-1 rounded text-xs transition-colors ${
          useThisLoading 
            ? 'bg-gray-400 text-white cursor-not-allowed' 
            : 'bg-green-500 text-white hover:bg-green-600'
        }`}
      >
        {useThisLoading ? (
          <div className="flex items-center">
            <img
              src={PhoneSpinner}
              alt="Loading"
              className="h-3 w-3 object-contain animate-spin mr-1"
            />
            Processing...
          </div>
        ) : (
          'Use This'
        )}
      </button>
                  </div>
                  <div className="mt-2 pt-2 border-t border-green-200">
                    <p className="text-xs text-gray-500">Or enter a new UPI ID below:</p>
                  </div>
                </div>
              )}
              
              {/* Input Field */}
              <div className="mb-6">
                <input
                  type="text"
                  placeholder="Enter UPI ID (e.g., 9876543210@paytm)"
                  value={upiId}
                  onChange={(e) => setUpiId(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-md text-gray-600 placeholder-[#A8A1A1] font-medium text-sm focus:outline-none focus:border-[#F43042] focus:ring-1 focus:ring-[#F43042]"
                  autoFocus={!lastUsedUpiId}
                />
              </div>

              {/* Save for Future Checkbox */}
              <div className="flex items-center mb-6">
                <div className="relative">
                  <input
                    type="checkbox"
                    id="saveForFuture"
                    checked={saveForFuture}
                    onChange={(e) => setSaveForFuture(e.target.checked)}
                    className="sr-only"
                  />
                  <div
                    className={`w-4 h-4 rounded border-2 flex items-center justify-center cursor-pointer ${
                      saveForFuture ? 'bg-red-500 border-red-500' : 'border-gray-300'
                    }`}
                    onClick={() => setSaveForFuture(!saveForFuture)}
                  >
                    {saveForFuture && (
                      <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                      </svg>
                    )}
                  </div>
                </div>
                <label htmlFor="saveForFuture" className="ml-2 text-xs text-[#000000] font-medium cursor-pointer">
                  Securely save for future use
                </label>
              </div>
              
              {/* Pay Button */}
              <button
                className={`w-full font-bold py-3 rounded-md text-sm transition-all duration-200 ${
                  upiId.trim() && !loading
                    ? 'bg-[#F43042] text-white hover:bg-red-600 transform hover:scale-[1.02]'
                    : 'bg-[#DCD7D7] text-[#FFFFFF] cursor-not-allowed'
                }`}
                onClick={handlePayClick}
                disabled={!upiId.trim() || loading}
                type="button"
              >
              {popupPayLoading ? (
    <div className="flex items-center justify-center">
      <img
        src={PhoneSpinner}
        alt="Loading"
        className="h-4 w-4 object-contain animate-spin mr-2"
      />
      Processing...
    </div>
  ) : (
    `Pay ₹${formattedAmount}`
  )}
</button>
           
            </div>
          </div>
        </>
      )}

{/* {pageLoading && (
            <div className="fixed inset-0 bg-white bg-opacity-80 backdrop-blur-sm z-50 flex items-center justify-center">
                <div className="text-center">
                    <img
                        src={PhoneSpinner}
                        alt="Loading"
                        className="h-16 w-16 object-contain animate-spin mx-auto mb-4"
                    />
                    <p className="text-gray-600 text-sm">Loading...</p>
                </div>
            </div>
        )} */}

    </div>
  );
};

export default UpiPayments;
